import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SentimentSatisfiedAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sentiment_satisfied_alt"}/>
}
